import { ActionContextBasic } from '../index'
import { Snack, SnackType } from '@/interfaces/snack'

export interface State {
  isFold: boolean,
  isLoading: boolean,
  appDrawerLayout: string
  pActive: number,
  sActive: number,
}

const state = () => ({
  isFold: false,
  isLoading: false,
  appDrawerLayout: 'column'
})

const mutations = {
  SET_IS_FOLD (state: State, val: boolean) {
    state.isFold = val
  },
  SET_IS_LOADING (state: State, val: boolean) {
    state.isLoading = val
  },
  CHANGE_APP_DRAWER_LAYOUT (state: State, val: string) {
    state.appDrawerLayout = val
  },
  UPDATE_P_ACTIVE (state: State, val: number) {
    state.pActive = val
  },
  UPDATE_S_ACTIVE (state: State, val: number) {
    state.sActive = val
  }
}

const actions = {
  setIsFold: (context: ActionContextBasic, val: boolean) => {
    context.commit('SET_IS_FOLD', val)
  },
  setIsLoading: (context: ActionContextBasic, val: boolean) => {
    context.commit('SET_IS_LOADING', val)
  },
  changeAppDrawerLayout: (context: ActionContextBasic, val: string) => {
    context.commit('CHANGE_APP_DRAWER_LAYOUT', val)
  },
  updatePActive: (context: ActionContextBasic, val: number) => {
    context.commit('UPDATE_P_ACTIVE', val)
  },
  updateSActive: (context: ActionContextBasic, val: number) => {
    context.commit('UPDATE_S_ACTIVE', val)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
